// LISTING
export const LISTINGS_SUCCESS = "GET ALL LISTINGS SUCCESSFUL";
export const LISTINGS_FAIL = "FAIL TO GET ALL LISTINGS";
